<template>
  <div class="game_main">
    <div class="down_ico">
      <img :src="datas.ico">
    </div>
    <div class="game_bg">
      <div class="txt_name">{{datas.title}}</div>
      <div class="txt_tips">{{datas.text}}</div>
    </div>
    <div class="game_down">
      <img class="down_img" v-if="datas.type === 'xcx_ma'" src="@/assets/xcx_ma.png" alt="">
      <img class="down_but" v-if="datas.type === 'h5'" src="@/assets/game/but_h5.png" alt="" @click="onClickDown('go_h5')">
      <img class="down_but" v-if="datas.type === 'xcx'" src="@/assets/game/but_xcx.png" alt="" @click="onClickDown('go_xcx')">
      <img class="down_but" v-if="datas.type === 'app'" src="@/assets/game/down_1.png" alt="" @click="onClickDown('down_now')">
    </div>
    <div style="clear: left;" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'GameListItem',
  components: {
  },
  props: [
    'datas', 'opts'
  ],
  data: () => {
    return {
    }
  },
  methods: {
    onClickDown (vtype) {
      console.log('GameListItem', this.datas)
      this.$emit('events', vtype, this.datas)
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.game_main {
  padding: 0.6rem 0;
  border-bottom: 1px #ddd solid;
}
.down_ico {
  float: left;
  padding: 0.6rem;
}
.down_ico img {
  width: 3.2rem;
}
.game_bg {
  float: left;
  width: 51%;
}
.txt_name {
  font-size: 0.9rem;
  font-weight: bold;
  text-align: left;
}
.txt_tips {
  font-size: 0.7rem;
  color: #888;
  text-align: left;
}
.game_down {
  float: left;
  margin-top: 1rem;
}
.down_but {
  margin: 0.3rem;
  margin-top: 0.6rem;
  width: 6rem;
}
.down_img {
  width: 6rem;
  margin-top: -1rem;
}
</style>
